import { css } from '@emotion/react';
import theme from 'shared/styles/themes';

export default css({
  '&.toggle-edit': {
    marginBottom: theme.space[4],
  },
});
